import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "assets-container" }
const _hoisted_2 = { class: "assets-header" }
const _hoisted_3 = { class: "assets-header-left" }
const _hoisted_4 = { class: "assets-header-left-text" }
const _hoisted_5 = { class: "currency-type" }
const _hoisted_6 = { class: "currency-type-net-value" }
const _hoisted_7 = { class: "currency-text" }
const _hoisted_8 = { class: "net-value-total" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "assets-type-info" }
const _hoisted_11 = { class: "assets-type-list" }
const _hoisted_12 = { class: "assets-type-list-item-text" }
const _hoisted_13 = { class: "assets-type-list-item-text-name" }
const _hoisted_14 = {
  key: 0,
  class: "assets-type-list-item-text-value"
}
const _hoisted_15 = {
  key: 1,
  class: "assets-type-list-item-text-value"
}
const _hoisted_16 = {
  key: 0,
  class: "dialog-currency-list"
}
const _hoisted_17 = ["onClick"]

import { Transition, watch } from 'vue'
import { formatThousandsKeepDecimal } from '@/utils/num_format'
import { computed, onMounted, reactive, ref } from 'vue'
import { useQuery, useQueryLoading } from '@vue/apollo-composable'
import { queryFundAssetAllInfo } from '@/graphql/holdings'
import storage, { StorageType } from '@/utils/storage'
import Decimal from 'decimal.js'
import * as echarts from 'echarts'
import { useStore } from 'vuex'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import useStock from '@/hooks/holdings/useStock'
import useFundAndBond from '@/hooks/holdings/useFundAndBond'
import useSps from '@/hooks/holdings/useSps'

interface Status {
  isShowCurrencyList: boolean
  eyeCloseText: string,
  isRefreshing: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Assets',
  setup(__props) {

const store = useStore()
const currencyActive = computed<{ name: string, value: string }>(() => {
  return store.state.holdings.currencyActive
})
const echartsDom = ref<echarts.ECharts | null>(null)

const status: Status = reactive({
  isShowCurrencyList: false,
  eyeCloseText: '**** ****',
  isRefreshing: false
})

// 货币数据
const currencyData = ref<{ ccy: string, baseCcy: string, rate: number }[]>([])
// 资产数据
const assetsData = ref({
  assetHkd: '0.00',
  assetHkdDispaly: '', // 资产净值显示
  childs: [], // 资产类型数据
  assetHkdValue: '0.00' // 资产净值值
})
// 货币列表
const currencyList = ref([
  {
    name: '港元',
    value: 'HKD'
  },
  {
    name: '美元',
    value: 'USD'
  },
  {
    name: '人民币',
    value: 'CNY'
  }
])
// 资产类型列表
const assetsType = ref<{ name: string, type: string, icon: string, value: string }[]>([
  {
    name: '股票',
    type: 'STOCK',
    icon: 'stock-icon',
    value: '0.00'
  },
  {
    name: '基金',
    type: 'FUND',
    icon: 'fund-icon',
    value: '0.00'
  },
  {
    name: '债券',
    type: 'BOND',
    icon: 'bond-icon',
    value: '0.00'
  },
  {
    name: '结构化票据',
    type: 'SPS',
    icon: 'otc-icon',
    value: '0.00'
  }
])

// echarts数据
const echartsData = ref<{ name: string, type: string, value: string, itemStyle: { color: string } }[]>([
  {
    name: '股票',
    type: 'STOCK',
    value: '0.00',
    itemStyle: {
      color: '#249EFF'
    }
  },
  {
    name: '结构化票据',
    type: 'SPS',
    value: '0.00',
    itemStyle: {
      color: '#3C70FF'
    }
  },
  {
    name: '债券',
    type: 'BOND',
    value: '0.00',
    itemStyle: {
      color: '#BA66FF'
    }
  },
  {
    name: '基金',
    type: 'FUND',
    value: '0.00',
    itemStyle: {
      color: '#FF8854'
    }
  }
])

const userData = computed(() => {
  const userId = storage.rcGetItem(StorageType.local, 'userInfo')
  const userName = storage.rcGetItem(StorageType.local, 'userName')
  return `${userName}账户总览(${userId})`
})

// 是否显示资产详情
const isShowAssetsDetail = computed(() => store.state.holdings.isShowAssetsDetail)

// 查询用户资产总览
const { onResult, refetch: refetchFundAssetAllInfo } = useQuery(queryFundAssetAllInfo, { filter: { fundAccount: storage.rcGetItem(StorageType.local, 'userInfo') } })
onResult((res) => {
  const { FundAssetAllInfo, EnquireCurrency } = res.data
  if (FundAssetAllInfo.ok) {
    assetsData.value = FundAssetAllInfo.data
    assetsType.value.map(item => {
      item.value = FundAssetAllInfo.data.childs.find(child => child.type === item.type)?.assetHkd || '0.00'
    })

    echartsData.value.map(item => {
      item.value = FundAssetAllInfo.data.childs.find(child => child.type === item.type)?.assetHkd
    })

    console.log(echartsData.value)
    echartsDom.value?.setOption({
      tooltip: {
        trigger: 'item',
        formatter: (params: { name: string, value: string, percent: number }) => {
          return `${params.name}: ${formatThousandsKeepDecimal(params.value, 2)}<br />占比: ${params.percent}%`
        }
      },
      series: [
        {
          type: 'pie',
          // width: 220,
          // height: 138,
          padAngle: 1,
          stillShowZeroSum: false,
          data: echartsData.value,
          radius: ['40%', '60%'],
          label: {
            edgeDistance: 10,
            fontSize: 10,
            formatter: '{b|{b}}\n{d|{d}%}',
            // labelLine: 'labelLine',
            rich: {
              b: {
                align: 'left'
              },
              d: {
                padding: [4, 0, 0, 0],
                align: 'left'
              }
            }
          }
        }
      ]
    })
  }
  if (EnquireCurrency.ok) {
    currencyData.value = EnquireCurrency.data
  }
})

// 格式化数值
const formatValue = (num: string) => {
  const rate = currencyData.value.find(item => item.ccy === store.state.holdings.currencyActive.value)?.rate || 1
  return formatThousandsKeepDecimal(new Decimal(num).div(rate).toString(), 2)
}

// 切换货币
const currencyClick = (item: { name: string, value: string }) => {
  store.commit(HoldingsMutationTypes.SET_CURRENCY_ACTIVE, item)
  status.isShowCurrencyList = false
  const data = echartsData.value.map(item => {
    const rate = currencyData.value.find(item => item.ccy === store.state.holdings.currencyActive.value)?.rate || 1
    return {
      ...item,
      value: new Decimal(item.value).div(rate).toString()
    }
  })
  echartsDom.value?.setOption({
    series: [
      {
        data: data
      }
    ]
  })
}

// 切换眼睛图标
const eyeIconClick = () => {
  storage.rcSetItem(StorageType.local, 'isShowAssetsDetail', !isShowAssetsDetail.value)
  store.commit(HoldingsMutationTypes.SET_IS_SHOW_ASSETS_DETAIL, !isShowAssetsDetail.value)
  echartsDom.value?.setOption({
    tooltip: {
      show: isShowAssetsDetail.value,
      trigger: 'item',
      formatter: (params: { name: string, value: string, percent: number }) => {
        return `${params.name}: ${formatThousandsKeepDecimal(params.value, 2)}<br />占比: ${params.percent}%`
      }
    },
    series: [
      {
        label: {
          formatter: isShowAssetsDetail.value ? '{b|{b}}\n{d|{d}%}' : '{b|{b}}'
        }
      }
    ]
  })
}

const { queryStockData } = useStock()
const { queryFundAndBondData } = useFundAndBond({ exchangeType: 'FUND' })
const { queryFundAndBondData: queryBondData } = useFundAndBond({ exchangeType: 'BOND' })
const { querySpsData } = useSps()

// 刷新资产
const refreshAssets = async () => {
  if (status.isRefreshing) return
  status.isRefreshing = true
  // 重新查询用户资产总览
  await refetchFundAssetAllInfo()
  switch (store.state.holdings.accountTypeActive.value) {
    case 'STOCK':
      queryStockData()
      break
    case 'FUND':
      queryFundAndBondData()
      break
    case 'BOND':
      queryBondData()
      break
    case 'SPS':
      querySpsData()
      break
    default:
      break
  }
  status.isRefreshing = false
}

onMounted(() => {
  echartsDom.value = echarts.init(document.getElementById('assets-charts') as HTMLElement)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "assets-header-left-icon" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(userData.value), 1)
      ]),
      _createElementVNode("div", {
        class: "assets-header-right",
        onClick: refreshAssets
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "assets-header-right-text" }, "刷新", -1)),
        _createElementVNode("i", {
          class: _normalizeClass(['assets-header-right-icon', { 'rotating': status.isRefreshing }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("i", {
          class: _normalizeClass([isShowAssetsDetail.value ? 'eye-icon-open' : 'eye-icon-close']),
          onClick: eyeIconClick
        }, null, 2),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "net-text" }, "资产净值", -1))
      ]),
      _createElementVNode("div", {
        class: "currency-type-change",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (status.isShowCurrencyList = !status.isShowCurrencyList))
      }, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(currencyActive.value.name), 1),
        _createElementVNode("i", {
          class: _normalizeClass(['currency-type-icon', { 'rotate': status.isShowCurrencyList }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (isShowAssetsDetail.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", null, _toDisplayString(formatValue(assetsData.value.assetHkd)), 1),
            _createElementVNode("span", null, _toDisplayString(currencyActive.value.value), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(status.eyeCloseText), 1))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[4] || (_cache[4] = _createElementVNode("div", {
        id: "assets-charts",
        class: "assets-charts"
      }, null, -1)),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetsType.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "assets-type-list-item",
            key: item.name
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['assets-type-list-item-icon', item.icon])
            }, null, 2),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.name), 1),
              (isShowAssetsDetail.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(formatValue(item.value)), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(status.eyeCloseText), 1))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "fade-currency-list" }, {
      default: _withCtx(() => [
        (status.isShowCurrencyList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "dialog-currency-list-item",
                  key: item.value
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(['dialog-currency-list-item-text', currencyActive.value.value === item.value ? 'active' : '']),
                    onClick: ($event: any) => (currencyClick(item))
                  }, _toDisplayString(item.name), 11, _hoisted_17)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})